import React from 'react';
import PropTypes from 'prop-types';

const StepInstruction = ({ ...props }) => {
  return (
    <div className='step-instruction'>
      <div className='step-label'>
        <span className='step-label-text'>STEP</span>
      </div>
      <div className='step-action'>
        <span className={props.bgcolor + ' step-badge'}>{props.badgeDisplay}</span>
      </div>
    </div>
  );
};

StepInstruction.propTypes = {
  bgcolor: PropTypes.string,
  badgeDisplay: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.number
  ])
};

export default StepInstruction;
